//Custom amino plugin
(function($) {
    "use strict";
    
    //amino slider plugin
    $.fn.aminoSlider = function (data) {
        
        return this.each(function() {

            //amino slider component
            var $aminoSliderComponent = $(this);
            var $min = ($aminoSliderComponent.attr('data-min') || 0);
            var $max = ($aminoSliderComponent.attr('data-max') || 1000);
            var $step = ('step', $aminoSliderComponent.attr('data-step') || 0);
            var $value = ($aminoSliderComponent.attr('data-value') || 50),
                debounce = function(func, wait, immediate) {
                    var timeout;
                    return function() {
                        var context = this, args = arguments;
                        var later = function() {
                            timeout = null;
                            if (!immediate) func.apply(context, args);
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) func.apply(context, args);
                    };
                };
            
            //slider template
            var $aminoSlider = $('<input class="am-slider" type="range"/>');
            
            //slider thumb
            var $aminoThumb = $('<div class="am-thumb"></div>');
            
            //slider tooltip template
            var $aminoTooltip = $('<div class="am-tooltip"></div>');

            // left image
            if(data.leftImage) {
                var $aminoLeftImage = $('<img class="tracker-image left" src="' + data.leftImage + '" />');
            } else {
                var $aminoLeftImage = $('');
            }

            if(data.rightImage) {
                var $aminoRightImage = $('<img class="tracker-image right" src="' + data.rightImage + '" />');
            } else {
                var $aminoRightImage = $('');
            }
            
            //slider configuration
            $aminoSlider.attr('min', $min);
            $aminoSlider.attr('max', $max);
            $aminoSlider.attr('step', $step);
            $aminoSlider.val($value);
            
            
            /*set state on event triggers*/
            var setRangePostions = function(event) {
                
                var rangeVal = $aminoSlider.val();
                var offsetWidth = $aminoSlider[0].offsetWidth;
                var offsetTop = $aminoSlider[0].offsetTop;
                var leftPostionInt = rangeVal/$max * (offsetWidth - 37);
                var leftPostion = leftPostionInt + 'px';
                var toolTipLeftPosition,
                    _fetchData;

                 if(data.callback) {
                    _fetchData = data.callback;
                 }

                if(leftPostionInt > 400) {
                    toolTipLeftPosition = leftPostionInt - 30 + 'px';
                } else {
                    toolTipLeftPosition = leftPostion;
                }

                //on all states set thumb position range
                $aminoThumb.css({'left': leftPostion});
                
                //on active state set tooltip top position
                if(event === 'mousedown') {
                    $aminoTooltip.css({'top': offsetTop-60});
                }

                //on normal state set thumb range value
                if(event === 'mouseup' || event === 'init') {
                    $aminoThumb.html(parseInt(rangeVal) + data.offset + data.tooltip);
                    data.week = parseInt(rangeVal) + data.offset;
                    if(event !== 'init') {
                        _fetchData(data);
                    }
                }
                
                //on drag or active state set tooltip range.
                if(event === 'change' || event === 'mousedown') {
                    $aminoTooltip.css({
                        'left': toolTipLeftPosition,
                        'margin-left': $aminoSlider[0].offsetLeft - 10 + 'px'
                    });
                }
            }
            
            //on active state
            $aminoSlider.on('mousedown touchstart', debounce(function() {      
                $aminoTooltip.addClass('am-tooltip-active-state');
                $aminoThumb.html('');
                $aminoTooltip.html(parseInt(this.value) + data.offset + data.tooltip);
                setRangePostions('mousedown');
            },300));
            
            //on normal state
            $aminoSlider.on('mouseup keyup touchend', debounce(function() {
                $aminoTooltip.removeClass('am-tooltip-active-state');
                setRangePostions('mouseup');
            },300));
                
            //on drag state
            $aminoSlider.on('input change touchmove', debounce(function() {
                //set value
                $aminoSliderComponent.attr('data-value', this.value);
                $aminoTooltip.html(parseInt(this.value) + data.offset + data.tooltip);
                setRangePostions('change');
            },300));

            $('.tracker-parent .btn-left').click(debounce(function() {
                var temp = parseInt($aminoSlider.val());
                $aminoSlider.val(temp-1);
                $aminoSliderComponent.attr('data-value', temp-1);
                $aminoTooltip.html(temp - 1 + data.offset + data.tooltip);
                setRangePostions('mouseup');
            },300));

            $('.tracker-parent .btn-right').click(debounce(function() {
                var temp = parseInt($aminoSlider.val());
                $aminoSlider.val(temp + 1);
                $aminoSliderComponent.attr('data-value', temp + 1);
                $aminoTooltip.html(temp + 1 + data.offset + data.tooltip);
                setRangePostions('mouseup');
            },300));
            
            //on window rezise
            $(window).on('resize', function(e) {
                setRangePostions();
            });
            
            //append slider template into amino component
            $aminoSliderComponent.append($aminoLeftImage, $aminoThumb, $aminoSlider, $aminoTooltip, $aminoRightImage);
            
            //init
            setRangePostions('init');         
        });
    };
    
})(jQuery);
define("Slider", ["jquery"], function(){});

